/// <summary name='cafm.hi' type='Object'>Container object for CAFM Hierarchy code</summary>
cafm.hi = {
    currentLocality: null,
    init: function () {
        /// <summary>Sets up the hierarchy controls</summary>

        // always set disabled to false, this can be set to true later in pipeline if required
        $('#hierarchy').removeData('disabled');
    },
    setup: function (parent, locality) {

        // setup cascading locality selector
        cafm.hi.casc.setup(parent, locality);
    },
    localityChanged: function (l) {
        /// <summary>Handles locality selection, updates the locality object state and ensures its validity</summary>
        /// <param name="l" type="Object">The locality object</param>

        cafm.forms.ensureDataLocalityId(l);

        cafm.hi.fireOnChange(l);
    },
    cleanLocality: function (l) {

        var type = cafm.enums.getEnumKey(cafm.enums.LocalityTypeData, l.LocalityType);
        var act;
        for (var k in cafm.hi.hierarchy.keys) {
            k = cafm.hi.hierarchy.keys[k];
            if (act) {
                l.set(k, null);
                l.set(k + 'ID', null);
            }
            if (type == k) {
                l.set('LocalityDescription', l.get(k));
                l.set('LocalityID', l.get(k + 'ID'));
                act = true;
            }
        }
    },
    getLocality(localityId, callback, loaderElement) {
        cafm.actions.execute({
            url: cafm.url.api(`locality/getdescription/${localityId}`),
            method: "GET",
            loaderTarget: loaderElement,
            success(locality) {
                callback(locality);
            }
        })
    },
    getCurrentLocality: function () {

        var cl = cafm.hi.currentLocality;

        if (isNullOrUndefined(cl)) {

            cl = $('#hierarchy .localityWidget').getViewModel();
        }

        return cl;
        
    },
    resetLocality: function(locality){

        var cid = cafm.auth.companyId();
        var cn = cafm.auth.companyName();
        locality.LocalityID = cid;
        locality.LocalityDescription = cn;
        locality.LocalityTrail = cn;
        locality.CompanyID = cid;
        locality.Company = cn;
        locality.LocalityType = cafm.enums.LocalityTypeData.Company;
    },
    setCurrentLocalityExplicitly: function (locality) {

        cafm.hi.currentLocality = locality;
    },
    setCurrentLocality: function (e) {
        /// <summary>Sets the current locality</summary>
        /// <param name="e" type="Object">Options object containing the locality</param>

        var hierarchy = $('#hierarchy .localityWidget');
        if (!hierarchy.length) return;

        // check for locality
        if (!e.locality) {

            console.log('cafm.hi.setCurrentLocality: locality is nothing');
            return;
        }

        //console.log(e.locality);

        var currentLocality;

        if (!e.setupNotRequired) {

            cafm.hi.setup(hierarchy, e.locality);
        }

        currentLocality = hierarchy.getViewModel();

        if (hierarchy.data('hasSetup') && !e.suppressChangeEvent) {
            cafm.hi.localityChanged(currentLocality);
        }

        hierarchy.data('hasSetup', true);

        cafm.forms.ensureDataLocalityId(currentLocality);
        cafm.hi.setCurrentLocalityLabel(currentLocality.get('LocalityDescription'));
        cafm.hi.casc.setCascadingCombosVisibility(cafm.hi.hierarchy.childMappings.Company.name, currentLocality, cafm.hi.casc.getAllowedLocalityDepth(), hierarchy);

        cafm.hi.showHierarchy();
    },
    updateCurrentLocality: function (id, name, type) {
        /// <summary>Updates the current locality</summary>
        /// <param name="id" type="String">The locality ID</param>
        /// <param name="name" type="String">The locality description</param>
        /// <param name="type" type="String">The locality type enum name</param>

        var currentLocality = cafm.hi.getCurrentLocality();
        if (currentLocality) {

            cafm.hi.updateLocality(currentLocality, id, name, type);
            cafm.hi.setCurrentLocalityLabel(name);
            cafm.hi.localityChanged(currentLocality);
            cafm.hi.casc.setCascadingCombosVisibility(cafm.hi.hierarchy.childMappings.Company.name, currentLocality, cafm.hi.casc.getAllowedLocalityDepth(), hierarchy);
        }
    },
    updateLocality: function (locality, id, name, type) {
        /// <summary>Updates the current locality</summary>
        /// <param name="locality" type="Object">The locality to update</param>
        /// <param name="id" type="String">The locality ID</param>
        /// <param name="name" type="String">The locality description</param>
        /// <param name="type" type="String">The locality type enum name</param>

        if (locality) {

            var localityType = cafm.enums.LocalityTypeData[type];
            locality.set('LocalityID', id);
            locality.set(type + 'ID', id);
            locality.set(type, name);
            locality.set('LocalityDescription', name);
            locality.set('LocalityType', localityType);
            cafm.hi.cleanLocality(locality);
            cafm.hi.rebuildLocalityTrail(locality);
        }
    },
    rebuildLocalityTrail: function (locality) {
        /// <summary>Updates the locality's trail</summary>
        /// <param name="locality" type="Locality">The locality to update</param>

        var parts = [];
        for (var k in cafm.hi.hierarchy.keys) {

            var part = locality.get(cafm.hi.hierarchy.keys[k]);
            if (part) {

                parts.push(part);
            }
        }

        locality.set('LocalityTrail', parts.join('\\'));
    },
    setCurrentLocalityLabel: function (name) {
        /// <summary>Sets the locality control description labels</summary>
        /// <param name="name" type="String">The locality name string</param>

        $('#localityDesc').text(name);
    },
    fireOnChange: function (l) {
        /// <summary>Fires any onchange events registered for the locality control</summary>
        /// <param name="f" type="Function">The locality object</param>

        cafm.handlers.exe('cafm.hi.hierarchyChanged', l);
    },
    registerOnChange: function (f) {
        /// <summary>Registers change events for the locality control</summary>
        /// <param name="f" type="Function">The onchange handler function</param>

        cafm.handlers.set('cafm.hi.hierarchyChanged', f);
    },
    deregisterOnChange: function () {
        /// <summary>Deregisters change events for the locality control</summary>

        cafm.handlers.remove('cafm.hi.hierarchyChanged');
    },
    localityTrailFromInfo: function(d){
        /// <summary>Generates a locality trail from an info object</summary>
        /// <param name="f" type="Function">The info object</param>

        var s = [];

        // add locality func
        var al = function (ld) {

            if (ld) {
                s.push(ld);
            }
        }

        al(d.LocationDescription);
        al(d.BuildingDescription);
        al(d.FloorDescription);
        al(d.ZoneDescription);
        al(d.SpaceDescription);
        al(d.RoomDescription);

        return s.join(' / ');
    },
    /// <field name='onChange' type='Array'>Contains on change helper functions mapped by key</field>
    onChange: [],
    hierarchy: {
        /// <field name='childMappings' type='Object'>Maps locality types to their child types</field>
        childMappings: {
            Company: { name: 'Location', api: 'Location' },
            Location: { name: 'Building', api: 'Building' },
            Building: { name: 'Floor', api: 'Floor' },
            Floor: { name: 'Zone', api: 'Zone' },
            Zone: { name: 'Space', api: 'Space' },
            Space: { name: 'Room', api: 'Room' },
            getParentKey: function (n) {
                /// <summary>Gets the parent locality type mapping object for a given locality type name</summary>
                /// <param name="n" type="String">The name of the child locality type</param>
                /// <returns type="String">A parent locality key string</returns>

                // handle workgroups spearately, as they don't fit with current child mappings methodology - they are used for selection alternatively to rooms in CAFM web
                if (n == 'WorkGroup') return 'Space';

                for (var k in cafm.hi.hierarchy.childMappings) {
                    var mapping = cafm.hi.hierarchy.childMappings[k];
                    if (mapping.name == n) return k;
                }
                return null;
            },
            getChild: (n, requiresWorkGroup) => {

                for (var k in cafm.hi.hierarchy.childMappings) {
                    var mapping = cafm.hi.hierarchy.childMappings[k];
                    if (k == n) {
                        if (mapping.name == 'Room' && requiresWorkGroup) {
                            return { name: 'WorkGroup', api: 'WorkGroup' }
                        }
                        return mapping;
                    }
                }
            }
        },
        keys: [
            'Company',
            'Location',
            'Building',
            'Floor',
            'Zone',
            'Space',
            'Room',
            'WorkGroup'
        ]
    },
    resetHierarchyToCompany: function () {

        var companyLocality = cafm.hi.getCurrentLocality();

        if (companyLocality) {

            companyLocality.set('LocalityType', cafm.enums.LocalityTypeData.Company);
            cafm.hi.cleanLocality(companyLocality);

            cafm.hi.setCurrentLocality({
                locality: companyLocality
            });
        }
        else {

            var companyId = cafm.auth.companyId(), companyName = cafm.auth.companyName()

            companyLocality = {
                                
                LocalityType: cafm.enums.LocalityTypeData.Company,
                LocalityTrail: companyName,
                LocalityID: companyId,
                LocalityDescription: companyName,
                CompanyID: companyId,
                Company: companyName
            };

            cafm.hi.localityChanged(companyLocality);
        }
    },
    setHierarchyFilterValues: function (id, desc) {

        var localityFilter = $('.cFilter .forLocality');

        if (id && desc) {

            cafm.lookup.setLookup({
                lookup: localityFilter,
                value: id,
                text: desc
            });
        }
        else {

            localityFilter.clearLookup({
                suppressEvents: true
            });
        }

        var searchBtn = $('#hierarchySearchBtn');

        if (!searchBtn.length) {
            searchBtn = $('<button />', {
                id: 'hierarchySearchBtn',
                text: 'Search',
                click: function () {
                    cafm.filters.search(cafm.filters.getPanel());
                }
            });
            searchBtn.insertAfter($('#hierarchy .localityWidget'));
        }
        else {
            searchBtn.show();
        }
    },
    hideHierarchySearchButton: function () {

        $('#hierarchySearchBtn').hide();
    },
    showHierarchy: function () {

        $('#hierarchy').show();
    },
    hideHierarchy: function () {

        $('#hierarchy').hide();
    },
    disableHierarchy: function () {

        $('#hierarchy').data('disabled', true);
    },
    disableHierarchyControls: function () {

        cafm.hi.disableHierarchy();

        $('#hierarchy').data('disabled', true).getComboBoxes().forEach(function (cb) {

            cb.enable(false);
        });
    },
    enableHierarchy: function () {

        var hierarchy = $('#hierarchy');

        hierarchy.removeAttr('disabled').removeData('disabled').getComboBoxes().forEach(function (cb) {

            cb.enable(true);
        });

        cafm.hi.casc.setCascadingCombosVisibility(cafm.hi.hierarchy.childMappings.Company.name, cafm.hi.getCurrentLocality(), cafm.hi.casc.getAllowedLocalityDepth(), hierarchy);
    },
    isHierarchyDisabled: function(){

        return $('#hierarchy').data('disabled') === true;
    },
    casc: {
        maxResultCount: 50,
        setup: function (parent, locality) {

        	// check for locality
            if (!locality) {

                console.log('cafm.hi.casc.setup: locality is nothing');
				return;
            }

            // ensure there is always a company id, even when empty as it will break the hierarchy control
            if (!cafm.util.guidHasValue(locality.CompanyID)) {

                locality.CompanyID = cafm.auth.companyId();

                // set company id as this will be used as hierarchy title
                locality.Company = cafm.auth.companyName();
            }

            var localityWidget = parent.hasClass('localityWidget') ? parent : $('.localityWidget', parent);

            if (localityWidget.length) {

                kendo.destroy(localityWidget);
                
                var wrappers = $('.localityCombos .cfComboBox', parent).setupComboBoxes();

                // CAFM-5380: ensure hierarchy locality combos are disabled if hierarchy selection is disabled
                if (localityWidget.closest('#hierarchy').length && cafm.hi.isHierarchyDisabled()) {
                    localityWidget.getComboBoxes().forEach(function (combo) {
                        combo.enable(false);
                    })
                }

                locality = localityWidget.bindViewModel({
                    viewModel: locality
                }).getViewModel();

                cafm.hi.cleanLocality(locality);

                // set combo text (as not auto bound)
                cafm.util.callFunctionAsync({
                    func: function () {
                        if (locality.Location) localityWidget.find('[name=LocationID]').getKendoComboBox().text(locality.Location);
                        if (locality.Building) localityWidget.find('[name=BuildingID]').getKendoComboBox().text(locality.Building);
                        if (locality.Floor) localityWidget.find('[name=FloorID]').getKendoComboBox().text(locality.Floor);
                        if (locality.Zone) localityWidget.find('[name=ZoneID]').getKendoComboBox().text(locality.Zone);
                        if (locality.Space) localityWidget.find('[name=SpaceID]').getKendoComboBox().text(locality.Space);
                        if (locality.Room) localityWidget.find('[name=RoomID]').getKendoComboBox().text(locality.Room);
                        if (locality.Workgroup) localityWidget.find('[name=WorkgroupID]').getKendoComboBox().text(locality.Workgroup);
                    },
                    timeout: 250
                });

                if (isMobile) {

                    wrappers.getComboBoxes().forEach(function (kcb) {

                        var input = kcb.input;

                        kcb.bind('open', function () {
                            
                            input = kcb.input;

                            if (!input.data('textboxFocused')) {

                                input.attr('readonly', 'true');

                                if (cafm.browsers.isBbMobile()) {

                                    input.blur();
                                }
                            }                            
                        });

                        input.off('click.cafm').on('click.cafm', function () {

                            input.removeAttr('readonly');
                            input.focus();
                            input.data('textboxFocused', true);

                            input.off('blur.cafm').on('blur.cafm', function () {

                                input.removeData('textboxFocused');
                            });
                        });
                    });
                }

                return locality;
            }
            else {

                return null;
            }
        },
        getAllowedLocalityDepth: function () {

            return $('#hierarchy').data('AllowedLocalityDepth');
        },
        setAllowedLocalityDepth: function (localityType) {

            $('#hierarchy').data('AllowedLocalityDepth', localityType);
        },
        localityDataSource: function (e) {

            var wrapper = e.wrapper,
                comboInput = $('input.cfControl', wrapper).not('.k-input'),
                key = comboInput.data('key'),
                dsUrl = cafm.url.api('CascadingLocality/{0}s'.format(comboInput.data('key'))),
                parentIdVar = '{0}ID'.format(cafm.hi.hierarchy.childMappings.getParentKey(key)),
                reqLocType = wrapper.closest('.localityCombos').data('requiredlocalitytype'),
                childMapping = cafm.hi.hierarchy.childMappings.getChild(key, reqLocType && reqLocType == cafm.enums.LocalityTypeData.WorkGroup);
            
            var isHierarchy = wrapper.closest('#hierarchy').length == 1;

            return new kendo.data.DataSource({
                transport: {
                    read: function (handler) {

                        var parent = wrapper.parents('.localityWidget:first'),
                            locality = parent.getViewModel(),
                            isDisabled = cafm.hi.isHierarchyDisabled();

                        if (locality && locality.get(parentIdVar)) {

                            var combo = comboInput.data('kendoComboBox');
                            var st = combo.element.data('searchText');

                            if (isHierarchy) {

                                combo.enable(!isDisabled);
                            }

                            cafm.actions.execute({
                                url: dsUrl,
                                method: 'POST',
                                values: {
                                    ParentId: locality.get(parentIdVar),
                                    MaxResultCount: cafm.hi.casc.maxResultCount,
                                    SearchText: st
                                },
                                statusCodeFuncs: {
                                    200: function (r, s, m) {

                                        // clear these flags to avoid 2 requests,
                                        // appears to be a Kendo bug as calling handler.success is the documented way but it duplicates the first requests for each combo.
                                        delete combo.dataSource._requestInProgress;
                                        delete combo.dataSource._pending;

                                        if (r.length && st) {

                                            r.forEach(loc => {
                                                if (!loc.ID && loc.Value) {
                                                    loc.ID = loc.Value;
                                                }
                                            });
                                        }

                                        // pass data to kendo success handler, populates combo items
                                        handler.success(r);

                                        // get search text
                                        st = combo.element.data('searchText');

                                        // if no results or search text..
                                        if (!r.length && !st) {

                                            combo.text(cafm.res.str.TextNothingAtThisLevel);
                                            combo.enable(false);
                                        }
                                        // if there are results and not disabled and there is a child combo..
                                        else if (r.length && !isDisabled && childMapping != null) {
                                            combo.enable(true);
                                            var childId = '{0}ID'.format(childMapping.name);
                                            var childCombo = $('input.cfControl[name="{0}"]'.format(childId)).data('kendoComboBox');

                                            if (childCombo) {

                                                childCombo.enable(true);
                                            }
                                        }
                                        else if (!r.length && combo.text() !== st) {

                                            combo.text(st);
                                        }

                                        // remove search text data if set..
                                        if (st) combo.element.removeData('searchText');
                                    }
                                }
                            });
                        }
                    }
                }
            });
        },
        localityKeyUp: function (e) {

            var kp = e.keyCode ? e.keyCode : e.charCode;

            if ([9, 13, 16, 27, 37, 38, 39, 40].indexOf(kp) > -1) {
                return true;
            }

            var wrapper = $(e.target).parents('.cfComboBox:first');
            var comboInput = $('[data-role="combobox"]', wrapper);
            var combo = comboInput.data('kendoComboBox');

            if (cafm.hi.casc.keyUp) clearTimeout(cafm.hi.casc.keyUp);
            cafm.hi.casc.keyUp = setTimeout(function () {
                combo.element.data('searchText', combo.text());
                combo.dataSource.read();
                combo.open();
                delete cafm.hi.casc.keyUp;
            }, 250);            
        },
        localityChanged: function (e) {

            e.preventDefault();
            var s = e.sender;
            
            if (isUndefined(s) || s.ns != '.kendoComboBox') {

                s = $(e.currentTarget).data('kendoComboBox');
            }

            var v = s.value(),
                t = s.text(),
                key = s.element.data('key'),
                parent = s.element.closest('.localityWidget'),
                currentLocality = parent.getViewModel();

            var clearLocality = function () {

                var parentKey = cafm.hi.hierarchy.childMappings.getParentKey(key),
                    parentId = currentLocality.get(parentKey + 'ID'),
                    parentText = currentLocality.get(parentKey);

                if (parent.data('hierarchy')) {

                    cafm.hi.updateCurrentLocality(parentId, parentText, parentKey);
                }
                else if (isMobile) {

                    cafm.hi.updateLocality(currentLocality, parentId, parentText, parentKey);
                }
                else {

                    cafm.hi.updateLocality(currentLocality, parentId, parentText, parentKey);
                }
            }

            if (v != t) {

                if (v) {

                    if (parent.data('hierarchy') && !isMobile) {

                        cafm.hi.updateCurrentLocality(v, t, key);
                    }
                    else if (isMobile) {

                        cafm.hi.updateLocality(currentLocality, v, t, key);
                    }
                    else {

                        cafm.hi.updateLocality(currentLocality, v, t, key);
                    }
                }
                else {

                    clearLocality();
                }
            }
            else if (t != currentLocality.get(key)) {

                if (s.selectedIndex == -1) {

                    clearLocality();
                }
            }

            // now populate child if necessary
            if (currentLocality.get(key + 'ID')) {
                
                let reqLocType = s.element.closest('.localityCombos').data('requiredlocalitytype'),
                    childMapping = cafm.hi.hierarchy.childMappings.getChild(key, reqLocType && reqLocType == cafm.enums.LocalityTypeData.WorkGroup);

                if (childMapping) {

                    var combo = $('.{0}Combo [data-role="combobox"]'.format(childMapping.name.toLowerCase()), parent);
                    var kCombo = combo.data('kendoComboBox');
                    if (kCombo) {

                        var placeholder = combo.data('placeholder');
                        kCombo.value('');
                        kCombo.text(placeholder ? placeholder : '');
                        kCombo.dataSource.read();
                    }
                }
            }

            cafm.hi.casc.setCascadingCombosVisibility(cafm.hi.hierarchy.childMappings.Company.name, currentLocality, cafm.hi.casc.getAllowedLocalityDepth(), parent);
        },
        setCascadingCombosVisibility: function (localityTypeName, locality, allowedDepth, parentElement) {

            if (localityTypeName == cafm.hi.hierarchy.childMappings.Company.name) {
                localityTypeName = cafm.hi.hierarchy.childMappings.Location.name;
            }

            if (!isJQuery(parentElement)) {

                parentElement = $(parentElement);
            }

            var parentIdVar = '{0}ID'.format(cafm.hi.hierarchy.childMappings.getParentKey(localityTypeName)),
                parentId = locality.get(parentIdVar),
                hasParentId = cafm.util.guidHasValue(parentId),
                comboWrapper = $('.{0}Combo'.format(localityTypeName.toLowerCase()), parentElement),
                isHierarchy = parentElement.closest('#hierarchy').length == 1,
                isDisabled = cafm.hi.isHierarchyDisabled();

            var nextCall = function () {

                let reqLocType = comboWrapper.closest('.localityCombos').data('requiredlocalitytype'),
                    childMapping = cafm.hi.hierarchy.childMappings.getChild(localityTypeName, reqLocType && reqLocType == cafm.enums.LocalityTypeData.WorkGroup);

                if (childMapping) {
                    cafm.hi.casc.setCascadingCombosVisibility(childMapping.name, locality, allowedDepth, parentElement);
                }
            }

            if (isHierarchy && isDisabled && hasParentId) {

                var currentId = '{0}ID'.format(localityTypeName);

                if (!cafm.util.guidHasValue(locality.get(currentId))) {

                    comboWrapper.hide();
                    nextCall();
                    return;
                }
            }
            
            var locType = cafm.enums.LocalityTypeData[localityTypeName];

            if (!hasParentId || locType < allowedDepth) {

                comboWrapper.hide();
            }
            else if (!allowedDepth || locType >= allowedDepth) {

                comboWrapper.show();
            }

            nextCall();
        }
    }
}